module.exports = __webpack_public_path__ + "img/circle-check.11982458.svg";